export const POST_TYPE = [
    { label: "Everyone", value: "EVERYONE" },
    { label: "Draft", value: "ONLY_ME" },
    { label: "Student", value: "STUDENT" },
]